/*
  getTheme.js
*/

/**
 * Helper function to get a box shadow value.
 *
 * Based on:
 * https://mui.com/material-ui/react-paper/
 */
function getBoxShadow(n) {

  const s1 = 'rgba(0,0,0,0.2)';
  const s2 = 'rgba(0,0,0,0.14)';
  const s3 = 'rgba(0,0,0,0.12)';

  // TODO: Add larger shadows and work out algorithm.

  switch (n) {
    case 1: return `${s1} 0px 2px 1px -1px, ${s2} 0px 1px 1px 0px, ${s3} 0px 1px 3px 0px`;
    case 2: return `${s1} 0px 3px 1px -2px, ${s2} 0px 2px 2px 0px, ${s3} 0px 1px 5px 0px`;
    case 3: return `${s1} 0px 3px 3px -2px, ${s2} 0px 3px 4px 0px, ${s3} 0px 1px 8px 0px`;
    case 4: return `${s1} 0px 2px 4px -1px, ${s2} 0px 4px 5px 0px, ${s3} 0px 1px 10px 0px`;
    case 24: return `${s1} 0px 11px 15px -7px, ${s2} 0px 24px 38px 3px, ${s3} 0px 9px 46px 8px`;
    default: return 'none';
  }
}

/**
 * Function that generates a theme.
 *
 * @param {Boolean} isDark - darkmode.
 *
 * @returns {Object} theme object.
 */
export default function getTheme(isDark = false) {

  // Main theme parameters.

  const theme = {

    light: !isDark,
    dark: isDark,

    xs: 600,
    sm: 900,
    md: 1200,
    lg: 1536,

    spacing: 8,

    font_family: "'Open Sans', Helvetica, Arial, sans-serif, -apple-system",
    
    color_background: isDark ? '#222222' : '#FFFFFF',
    color_paper: isDark ? '#333333' : '#FFF',
    color_divider: isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',

    color_text_primary: isDark ? '#FFFFFF' : 'rgba(0,0,0,0.87)',
    color_text_secondary: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
    color_text_disabled: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.38)',

    action_hover: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
    action_disabled: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)',

    color_primary_main: isDark ? '#C675D7' : '#805ad6',
    color_primary_contast_text: '#FFF',

  };

  // Helper functions to help get theme values.

  theme.space = (...args) => args.map(n => `${n * theme.spacing}px`).join(' ');
  theme.breakpointUp = (bk) => `@media (min-width: ${theme[bk]}px)`;
  theme.breakpointDown = (bk) => `@media (max-width: ${theme[bk] - 1}px)`;
  theme.shadow = (n) => getBoxShadow(n);

  return theme;

}
